import { StyleSheet } from "react-native";
import Metrics from "../../Theme/Metrics";

export const avatarCircleStyles = StyleSheet.create({
    container: {
        width: Metrics.horizontalScale(70),
        height: Metrics.horizontalScale(70),
        borderRadius: Metrics.moderateScale(35),
    }
})